import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase/firebase-config';
import { signInWithEmailAndPassword } from 'firebase/auth';
import './LoginModal.css';
import { companies } from '../CompanyInfo/companies';

function LoginModal({ isOpen, onClose, onLogin }) {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        credentials.email,
        credentials.password
      );
      
      const user = userCredential.user;
      
      // Sjekk brukertype basert på e-post
      const isAdmin = user.email === "admin@purepaths.com";
      const isBakerUser = user.email.endsWith('@ppbaker.com');
      const isTessUser = user.email.endsWith('@pptess.com');
      const isHR = user.email.startsWith('hr.') || 
                   companies.tess.hr.emails.includes(user.email) ||
                   companies.baker.hr.emails.includes(user.email);
      const isAppUser = (isBakerUser || isTessUser) && !isHR;

      const userData = {
        email: user.email,
        isAdmin,
        isHR,
        isAppUser,
        companyName: isAdmin 
          ? "Pure Paths Admin" 
          : isBakerUser 
            ? "Baker Hughes Stord"
            : "Tess Stord",
        role: isHR ? 'hr' : 'user'
      };

      // Lagre brukerdata
      localStorage.setItem('userToken', await user.getIdToken());
      localStorage.setItem('user', JSON.stringify(userData));

      onLogin(userData);
      
      // Videresend til riktig dashboard
      if (isHR) {
        navigate('/hr-dashboard');
      } else if (isAdmin) {
        navigate('/admin');
      } else if (isAppUser) {
        navigate('/app-interface');
      } else {
        navigate('/dashboard');
      }
      
    } catch (error) {
      console.error('Login error:', error);
      setError('Feil e-post eller passord');
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    if (error) setError('');
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>Login to Pure Paths</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="login-submit-button">
            Login
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginModal; 